import {PaymentDeviceType} from "./payment-device-type";
import {Injectable} from "@angular/core";
import {Adapter} from "../../../shared-module/adapter/adapter";

export class PaymentUserData{
  constructor(
       public languageCode: string,
       public paymentDeviceType: PaymentDeviceType,
       public amount: string,
       public accountIdentity: string,
       public phone: string,
       public email: string,
       public token: string){}

}

@Injectable()
export class PaymentUserDataAdapter implements Adapter<PaymentUserData> {

  adaptOut(userData: PaymentUserData): any {
    return {
      "LanguageCode": userData.languageCode,
      "PaymentDeviceType": userData.paymentDeviceType,
      "Amount": userData.amount,
      "AccountIdentity": userData.accountIdentity,
      "Phone": userData.phone,
      "Email": userData.email,
      "Token": userData.token,
    }
  }

  adaptIn(item: any): PaymentUserData {
    return new PaymentUserData(item.languageCode, item.paymentDeviceType, item.amount,
        item.accountIdentity, item.phone, item.email, item.token);
  }
}


// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/widget/payment-widget/models/payment-user-data.ts